<template>
  <div class="expanded-row-content">
    <v-card 
      :color="user.is_intervened ? '#c3ecff' : '#f5f8fc'"
    >
      <v-overlay :value="contactHistoryLoading" :absolute="absolute"></v-overlay>
      <v-row no-gutters>
          <v-col :cols="12">
              <h4 style="padding-left: 15px; padding-top: 15px;">
                  Contacto con el paciente
              </h4>
          </v-col>
          <v-col :cols="12">
            <symptoms :user="user" />
          </v-col>
      </v-row>
      <contact-history 
        :user="user"
        @cancelComment="$emit('cancelComment')"
      />
    </v-card>
</div>
</template>

<script>

  import Symptoms from './Symptoms'
  import ContactHistory from './ContactHistory'

  export default {
    name: 'MyUserCardExpansion',

    components: {
      Symptoms,
      ContactHistory
    },

    props: {
      user: {
        type: Object,
        required: true
      }
    },

    data: () => ({
      absolute:true,
    }),

    computed: {
      contactHistoryLoading() {
          return this.$store.getters['contact_history/contactHistoryLoading']
      },
    },
  }
</script>
